import { CheckCircleIcon, InfoIcon, XCircleIcon } from 'lucide-react'

import RichText from '@/components/RichText'
import { cn } from '@/utilities/ui'

import type { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'

type FormMessageProps = {
  type: 'success' | 'error' | 'info'
  message: string | DefaultTypedEditorState
  className?: string
}

export const FormMessage: React.FC<FormMessageProps> = (props: FormMessageProps) => {
  const { type, message, className } = props

  return (
    <div
      role="alert"
      className={cn(
        'flex w-fit items-center gap-2 rounded-xl border p-4 font-body',
        type === 'success'
          ? 'border-evergreen-200 bg-evergreen-100'
          : type === 'error'
            ? 'border-error/50 bg-error'
            : 'border-border bg-secondary',
        className,
      )}
    >
      {type === 'success' ? (
        <CheckCircleIcon className="size-4 shrink-0 text-evergreen-700" />
      ) : type === 'error' ? (
        <XCircleIcon className="size-4 shrink-0 text-destructive-foreground" />
      ) : (
        <InfoIcon className="size-4 shrink-0 text-secondary-foreground" />
      )}
      {typeof message === 'string' ? (
        <p
          className={cn(
            'm-0 text-sm font-medium',
            type === 'success'
              ? 'text-evergreen-700'
              : type === 'error'
                ? 'text-destructive-foreground'
                : 'text-secondary-foreground',
          )}
        >
          {message}
        </p>
      ) : (
        <div
          className={cn(
            'm-0 text-sm font-medium',
            type === 'success'
              ? 'text-evergreen-700'
              : type === 'error'
                ? 'text-destructive-foreground'
                : 'text-secondary-foreground',
          )}
        >
          <RichText data={message} />
        </div>
      )}
    </div>
  )
}
